import isObject from 'is-object';

export default (obj) => (isObject(obj) ? obj.id : obj);
